import { styled } from '@mui/material/styles';
import { Typography } from 'core/common/ui/ui-kit';

export const CaptionStyled = styled(Typography)`
  width: 100%;
  padding: 8px 12px;
  border-left: 2px solid ${({ theme }) => theme.palette.payment.errorCaptionBorder};
  border-radius: 0 4px 4px 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  background: ${({ theme }) => theme.palette.payment.errorCaption};

  & a {
    color: ${({ theme }) => theme.palette.text.accent};
  }
`;
